import {
  PhotoSquareOutlineIcon as ImageVariableIcon,
  TextOutlineIcon as TextVariableIcon,
} from '@carboncopyco/icons';
import type { IVariable } from '@carboncopyco/types';
import { RuleIcon, type RuleIconProps } from '../RuleIcon';

export interface VariableIconProps extends Pick<RuleIconProps, 'size'> {
  type: IVariable['type'];
}

export const VariableIcon = ({ size, type }: VariableIconProps) => {
  return (
    <RuleIcon size={size}>
      {type === 'text' ? <TextVariableIcon /> : <ImageVariableIcon />}
    </RuleIcon>
  );
};
